export default __webpack_public_path__ + "static/media/StrangerThings.5c8c1e25.mp3";